import 'css-chunksrc/client/scenes/wbs/event/styles.scss';export default {
  "event": "_event_1nalk_1",
  "contextualMenu": "_contextualMenu_1nalk_7",
  "hovered": "_hovered_1nalk_11",
  "icon": "_icon_1nalk_14",
  "eventDetails": "_eventDetails_1nalk_18",
  "name": "_name_1nalk_25",
  "taskAdvancement": "_taskAdvancement_1nalk_44",
  "taskAdvancementWrapper": "_taskAdvancementWrapper_1nalk_50",
  "removeIcon": "_removeIcon_1nalk_63",
  "status": "_status_1nalk_67",
  "allocations": "_allocations_1nalk_74",
  "text": "_text_1nalk_81",
  "tick": "_tick_1nalk_87",
  "late": "_late_1nalk_94",
  "displayContextualMenu": "_displayContextualMenu_1nalk_105",
  "placeholder": "_placeholder_1nalk_109",
  "allocated": "_allocated_1nalk_114",
  "done": "_done_1nalk_118"
};